import React from 'react';

import { HStack, Typography } from '@rbilabs/universal-components';

import { formatNumber, t } from 'state/intl/translations';
import { getUnitForNutrient } from 'utils/menu';

import { NutrientItem } from '../use-nutrient-items';

type Props = {
  nutrients: NutrientItem[];
};

export const NutrientList = ({ nutrients }: Props) => {
  return (
    <>
      {nutrients.map(({ label, value }) => (
        <HStack
          key={label}
          justifyContent="space-between"
          alignItems="center"
          marginTop={1}
          focusable
        >
          <Typography style={{ textTransform: 'capitalize' }}>{t(`us-${label}`)}</Typography>
          <Typography>
            {label === 'calories'
              ? `${formatNumber(Math.floor(value), {
                  maximumFractionDigits: 0,
                })} ${getUnitForNutrient(label)}`
              : `${formatNumber(value, { maximumFractionDigits: 1 })} ${getUnitForNutrient(label)}`}
          </Typography>
        </HStack>
      ))}
    </>
  );
};
